import { EBroadcastTypes, Session } from '@/types/session.types';
import { TBroadcastTypePickerOptions } from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/broadcast-type-picker.types';
import { BROADCAST_TYPE_OPTIONS } from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/broadcast-type-picker/broadcast-type-options';

const VALID_BROADCAST_TYPES = new Set<TBroadcastTypePickerOptions>(BROADCAST_TYPE_OPTIONS);

const getSelectedBroadcastType = (session?: Session | null): TBroadcastTypePickerOptions => {
  const broadcastType = session?.broadcast_type;

  if (broadcastType === EBroadcastTypes.rtmps) {
    const rtmpSource = session?.streaming_options?.rtmp_source;
    if (rtmpSource === 'teams' || rtmpSource === 'zoom') {
      return rtmpSource;
    }
    return EBroadcastTypes.rtmps;
  }

  if (broadcastType && VALID_BROADCAST_TYPES.has(broadcastType)) {
    return broadcastType as TBroadcastTypePickerOptions;
  }
  return EBroadcastTypes.greenroom;
};

export default getSelectedBroadcastType;
